import { _axiosMain, AddAuthSession } from './axios'

const SIGNIN = `/signin`

export const authApi = () => {
  const signin = async (id: string, pass: string): Promise<string> => {
    return await _axiosMain()
      .post(SIGNIN, {
        loginId: id,
        password: pass,
      })
      .then((x) => {
        AddAuthSession(x.data.access_token)
        return x.data.id
      })
  }

  return {
    signin,
  }
}
